import { render, staticRenderFns } from "./PanelPlain.vue?vue&type=template&id=52c699db&"
import script from "./PanelPlain.vue?vue&type=script&lang=js&"
export * from "./PanelPlain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c699db')) {
      api.createRecord('52c699db', component.options)
    } else {
      api.reload('52c699db', component.options)
    }
    module.hot.accept("./PanelPlain.vue?vue&type=template&id=52c699db&", function () {
      api.rerender('52c699db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/panels/PanelPlain.vue"
export default component.exports